var RMagento = {
    /** 
        Saving design in magento server
        @params image, customer id, design id, url, pdf url
    */
    saveDesign: function(data) {
        var headers = {
            'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
        }
        
        var url = ub.config.host + '/richardson/save-design';

        ub.utilities.ajaxPostJSON(headers, url, data, function(response) {
            RMagento.onSuccessSavedDesign(response);
        }, function(error) {
            RMagento.onFailedSavedDesign();
        });
    },

    saveDesignV2: function(data) {
        var postMessageData = {
            action: "save_design",
            data: data
        };

        parent.postMessage(postMessageData, ub.config.magentoURL);
    },

    onFailedSavedDesign: function() {
        var render = DesignPreview.events.showAlertMessage("Something went wrong! Please try again." , "danger");
        $(".save-design-container .message-container").html("");
        $(".save-design-container .message-container").html(render);

        $("#richardson-saving-option .uniform-thumbnail-container").removeClass("uk-hidden");
        $('#richardson-saving-option .save-design-loading').fadeOut();

        DesignPreview.events.hideMessage();
    },

    onSuccessSavedDesign: function(response) {
        var render;

        if (response.status) {
            let savedDesignID = ub.current_material.settings.savedDesignID;
            let url = DesignPreview.events.getSavedDesignRedirectUrl();
            
            ub.data.isSavedDesign = true;
            
            $(".save-design-container .goto-mysaved-design").removeClass("uk-hidden");
            $(".save-design-container .view-container").html("");
            $(".save-design-container .view-container")
                .html(`<a target="_blank" class="uk-button uk-width-1-1 fc-white bgc-darkGray abrade-ultra-italic hov-red" href="${url}"> View ${savedDesignID}</a>`);
                
            render = DesignPreview.events.showAlertMessage("Your design saved sucessfully", "success");

            $("#richardson-saving-option .pdf-container").html("");
            $("#richardson-saving-option .pdf-container").html('<a class="uk-button uk-button-default" href="'+ ub.current_material.settings.pdfOrderForm +'" target="_blank"><span uk-icon="cloud-download"></span> Download PDF</a>');
        } else {
            render = DesignPreview.events.showAlertMessage(response.message, "danger");
        }

        $(".save-design-container .message-container").html("");
        $(".save-design-container .message-container").html(render);

        $("#richardson-saving-option .uniform-thumbnail-container").removeClass("uk-hidden");
        $('#richardson-saving-option .save-design-loading').fadeOut();

        DesignPreview.events.hideMessage();
    },

    saveDesignPostMessage: function(response) {
        var render;

        if (response.success) {
            let savedDesignID = ub.current_material.settings.savedDesignID;
            let url = DesignPreview.events.getSavedDesignRedirectUrl();

            ub.data.isSavedDesign = true;
            
            $(".save-design-container .goto-mysaved-design").removeClass("uk-hidden");
            $(".save-design-container .view-container").html("");
            $(".save-design-container .view-container")
                .html(`<a target="_blank" class="uk-button uk-width-1-1 fc-white bgc-darkGray abrade-ultra-italic hov-red" href="${url}"> View ${savedDesignID}</a>`);
            
            render = DesignPreview.events.showAlertMessage("Your design saved sucessfully", "success");

            $("#richardson-saving-option .pdf-container").html("");
            $("#richardson-saving-option .pdf-container").html('<a class="uk-button uk-button-default" href="'+ ub.current_material.settings.pdfOrderForm +'" target="_blank"><span uk-icon="cloud-download"></span> Download PDF</a>');
        } else {
            render = DesignPreview.events.showAlertMessage(response.message, "danger");
        }

        $(".save-design-container .message-container").html("");
        $(".save-design-container .message-container").html(render);

        $("#richardson-saving-option .uniform-thumbnail-container").removeClass("uk-hidden");
        $('#richardson-saving-option .save-design-loading').fadeOut();

        DesignPreview.events.hideMessage();
    },

    /** 
        Sending email in magento server
        @params dealer_email, your_email, your_name, message, pdf_url, pdf_name, design_number, design_url, image_url
    */
    sendEmail: function(data) {
        var headers = {
            'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
        }

        var url = ub.config.host + "/richardson/send-email";

        ub.utilities.ajaxPostJSON(headers, url, data, function(response) {
            var render;
            if (response.status) {
                render = DesignPreview.events.showAlertMessage(response.message, "success");
            } else {
                render = DesignPreview.events.showAlertMessage(response.message, "danger");
            }

            $(".send-design-container .message-container").html("");
            $(".send-design-container .message-container").html(render);
            DesignPreview.events.hideLoader();
            DesignPreview.events.hideMessage();

            grecaptcha.reset(DesignPreview.events.reCaptcha);
        }, function(error) {
            var render;

            if (error.status === 422) {
                render = DesignPreview.events.showAlertMessage("Invalid recaptcha", "danger");
            } else {
                render = DesignPreview.events.showAlertMessage("Something went wrong. Please try again.", "danger");
            }

            $(".send-design-container .message-container").html("");
            $(".send-design-container .message-container").html(render);

            DesignPreview.events.hideLoader();
            DesignPreview.events.hideMessage();

            grecaptcha.reset(DesignPreview.events.reCaptcha);
        });
    },

    /** 
        Create user in magento
        @params name, email, password
    */
    registerUser: function(data) {
        var headers = {
            'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
        };

        var render;

        var url = ub.config.host + '/richardson/register';

        ub.utilities.ajaxPostJSON(headers, url, data, function(response) {
            if (response.status) {
                // Save USer
                window.ub.user = {
                    id: parseInt(response.id),
                    fullname: response.fullname,
                    firstName: response.firstName,
                    lastName: response.lastName,
                    email: response.email,
                    type: response.type,
                    origin: "design-preview"
                };

                ub.current_material.settings.userFullName = response.fullname;
                
                ub.id = response.id;
                ub.funcs.afterLogin();

                PdfPanel.regeneratePdf(function() {
                    DesignPreview.events.hideLoader();
                    DesignPreview.events.showSavedDesign();

                    render = DesignPreview.events.showAlertMessage(response.message, "success");
                    
                    $(".save-design-container .message-container").html("");
                    $(".save-design-container .message-container").html(render);
                });
            } else {
                DesignPreview.events.hideLoader();
                render = DesignPreview.events.showAlertMessage(response.message, "danger");

                $(".registration-container .message-container").html("");
                $(".registration-container .message-container").html(render);
            }

            DesignPreview.events.hideMessage();
        }, function(err) {
            DesignPreview.events.hideLoader();
            var template = document.getElementById("m-alert-message").innerHTML;
            render = Mustache.render(template, {message: "Something went wrong."});

            $(".registration-container .message-container").html("");
            $(".registration-container .message-container").html(render);
        });
    }
};